import React from 'react';

export const JoyLogo: React.FC<{ fillColor?: string }> = ({ fillColor }) => {
  return (
    <svg
      height="24px"
      viewBox="0 0 61 39"
      fill="none"
    >
      <path
        d="M52.565 14.48c-2.368-9.849-9.258-5.203-10.454-3.672a.124.124 0 00.114.198c5.134-.736 6.248 16.994 4.17 23.373-.04.12.107.215.201.13 1.69-1.519 8.708-8.646 5.97-20.03zM60.828 13.137c.35-1.643.378-4.192-2.01-4.958-1.704-.547-4.907 1.301-3.01 4.418.868 1.429 2.505 5.034 1.227 8.895-.046.14.145.233.223.107 1.069-1.725 2.846-5.052 3.57-8.462zM44.704 35.842c.132-.04.222.132.113.218-1.825 1.433-3.497 2.09-5.51 1.997-4.484-.205-4.692-3.777-3.37-5.414.647-.802 2.106-1.709 3.024-1.673a.122.122 0 01.106.17c-.844 2.056.903 6.115 5.637 4.702z"
        fill={fillColor ?? '#4951EF'}
      ></path>
      <path
        d="M34.223 8.41c-3.435 0-6.469 1.34-8.878 3.347-2.499 2.14-4.461 5.844-4.551 9.547 0 5.041 3.614 8.342 8.878 8.342 3.257 0 6.38-1.249 8.699-3.301 2.543-2.186 4.595-5.978 4.595-9.68 0-4.998-3.657-8.254-8.743-8.254zm1.378 9.545c-.306 1.174-2.184 8.28-4.962 9.728-4.005 2.087-2.928-5.645-2.385-7.625.321-1.17 2.18-8.358 4.962-9.727 3.973-1.954 2.743 6.253 2.385 7.624zM1.446 27.478c.086.089.238.011.212-.11-.29-1.32 1.114-3.307 3.765-3.109 1.656.125 2.499-2.507 1.132-3.893-1.693-1.715-4.217-1.04-5.481.746-1.96 2.77-.87 5.082.372 6.366zM6.57 29.384c-.152.018-.141.24.01.247 3.647.171 11.067-1.44 13.221-10.356.65-2.689 2.446-10.102 2.942-12.163 1.03-4.282 1.75-5.822 2.371-6.34a.123.123 0 00-.027-.207c-1.3-.585-7.385-2.22-9.083 5.28-.228 1.009-2.5 10.92-2.764 12.04-2.105 8.883-4.126 11.191-6.67 11.499z"
        fill={fillColor ?? '#4951EF'}
      ></path>
    </svg>
  );
};
